module.exports = __webpack_public_path__ + "img/mp3.532f79d9.png";